import {
  ICellEditorOption,
  IExcelCellOption,
} from "@/components/excel/schema/ConfigSchema";
import "@/utils/extensions/libs/ArrayExtension";
import { ICellStyle } from "@/components/excel/schema/StyleSchema";
import { generateArray } from "@/utils/excel/CommonDataSource";
import "@/utils/extensions/libs/NumberExtension";
import { toExcelColumnLabel } from "@/utils/excel/ColumnConfig";
export interface IRow {
  /**
   * 行号
   * 全局的行号
   */
  index: number;
  /**
   * 是否在垂直滚动时固定在顶部
   */
  sticky: boolean;
  /**
   * 行内的单元格
   */
  cells: IExcelCellOption[];
  /**
   * 固定的高度
   */
  height?: number | string;
  /**
   * 固定的style 而不是 style method 动态获取的style
   */
  style?: ICellStyle;
  selected: boolean;
}

export interface IColumn {
  /**
   * 列号
   */
  index: number;
  text: string;
  /**
   * 列的属性
   */
  property: number;
  width: number | string;
  /**
   * 固定的style 而不是 style method 动态获取的style
   */
  style?: ICellStyle;
  selected: boolean;
}

export function createCell(editor?: ICellEditorOption): IExcelCellOption {
  return { text: "", span: { colSpan: 1, rowSpan: 1 }, editor };
}

export function mergeCells(
  cells: IExcelCellOption[],
  columns: number,
  editor?: ICellEditorOption
): IExcelCellOption[] {
  if (cells.length >= columns) {
    return cells;
  }
  const additional = Array.from(Array(columns - cells.length)).map(() =>
    createCell(editor)
  );
  return cells.concat(additional);
}

export function createRow(
  cells: IExcelCellOption[],
  index: number,
  columns: number,
  sticky: boolean,
  height?: number | string,
  editor?: ICellEditorOption
): IRow {
  return {
    index,
    sticky,
    cells: mergeCells(cells, columns, editor),
    selected: false,
    height,
  };
}

export function createEmptyRow(
  index: number,
  columns: number,
  height?: number | string,
  editor?: ICellEditorOption
): IRow {
  return createRow([], index, columns, false, height, editor);
}

export function mergeRows(
  cells: IExcelCellOption[][],
  rows: number,
  columns: IColumn[],
  editor?: ICellEditorOption
): IRow[] {
  const columnSize = columns.length;
  if (cells.length >= rows) {
    return cells.map((it, idx) =>
      createRow(it, idx, columnSize, false, undefined, editor)
    );
  }
  return Array.from(Array(rows)).map((it, idx) => {
    const row = cells[idx];
    if (row) {
      return createRow(row, idx + 1, columnSize, false, undefined, editor);
    }
    return createEmptyRow(idx + 1, columnSize, undefined, editor);
  });
}

export function computeRows(
  cells: IExcelCellOption[][],
  minRows: number,
  minEmptyRows: number
): number {
  return Math.max(minRows, cells.length + minEmptyRows);
}

export function computeColumns(
  cells: IExcelCellOption[][],
  minColumns: number,
  minEmptyColumns: number
): number {
  const maxCellCols = cells.max((it) => it.length);
  return Math.max(minColumns, maxCellCols + minEmptyColumns);
}

export function createColumns(cols: number): IColumn[] {
  const texts = generateArray(cols).map((it) => toExcelColumnLabel(it));
  return texts.map((it, idx) => {
    return {
      text: it,
      property: idx,
      index: idx + 1,
      selected: false,
      width: "100px",
    };
  });
}

export function createColumnsByCells(cells: IExcelCellOption[][]) {}
